import { NavLink, useLocation } from "react-router-dom";
import { useEffect } from "react";
import * as bootstrap from "bootstrap";

export default function MobileMenu() {
  const location = useLocation();

  useEffect(() => {
    const offcanvas = document.querySelector("#mobileMenu");
    if (offcanvas) {
      const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvas);
      if (bsOffcanvas) bsOffcanvas.hide();
    }
  }, [location.pathname]);

  return (
    <div
      className="offcanvas offcanvas-start text-bg-dark"
      tabIndex="-1"
      id="mobileMenu"
    >
      <div
        className="offcanvas-header border-bottom"
        style={{ backgroundColor: "#fff" }}
      >
        <h5 className="offcanvas-title mb-0" id="mobileMenuLabel">
          <img
            src="/logo192.jpeg"
            alt="Logo LAFAPE"
            loading="lazy"
            style={{
              height: "48px",
              width: "auto",
              objectFit: "contain",
              borderRadius: "6px",
              backgroundColor: "#fff",
              padding: "2px"
            }}
          />
        </h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>

      <div className="offcanvas-body d-flex flex-column gap-3 px-3 pt-4">
        <NavLink to="/" className="btn btn-outline-light w-100">
          Accueil
        </NavLink>
        <NavLink to="/catalogue" className="btn btn-outline-light w-100">
          Machines Agricoles
        </NavLink>
        <NavLink to="/colisage" className="btn btn-outline-light w-100">
          Colisage & Suivi
        </NavLink>
        <NavLink to="/a-propos" className="btn btn-outline-light w-100">
          À propos
        </NavLink>
        <NavLink to="/contact" className="btn btn-outline-light w-100">
          Contact
        </NavLink>
        <NavLink to="/explorer" className="btn btn-bridge mt-4">
          Voir les marques
        </NavLink>
      </div>
    </div>
  );
}
